module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/hero_mob-339265e0b199bf3af801cd3ff69b9826.jpg";